import { Link, useLocation } from "react-router-dom";
import { LayoutDashboard, MoreHorizontal, Sparkles } from "lucide-react";
import { cn } from "@/cn";
import { ProfileMenu } from "@/components/profile-menu";
import { isActivePath } from "@/lib/nav-items";
import { todayHref } from "@/lib/today-position";
import { useMobileNav } from "@/components/mobile-nav-context";

export function MobileBottomNav() {
  const { pathname } = useLocation();
  const { drawerOpen, openDrawer, closeDrawer } = useMobileNav();
  const tabs = [
    { id: "today", href: todayHref(), label: "Today", icon: LayoutDashboard },
    {
      id: "assistant",
      href: "/ai-assistant",
      label: "Assistant",
      icon: Sparkles,
    },
  ] as const;

  return (
    <nav
      aria-label="Primary"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-bg md:hidden"
      style={{
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
    >
      <ul className="flex h-14 items-stretch">
        {tabs.map((tab) => {
          const active = isActivePath(tab.href, pathname);
          const Icon = tab.icon;
          return (
            <li key={tab.id} className="flex-1">
              <Link
                to={tab.href}
                onClick={() => closeDrawer()}
                className={cn(
                  "flex h-full flex-col items-center justify-center gap-0.5 text-[10px] font-medium",
                  active
                    ? "text-brand"
                    : "text-muted-foreground hover:text-foreground",
                )}
                aria-current={active ? "page" : undefined}
              >
                <Icon className="size-5" aria-hidden />
                <span>{tab.label}</span>
              </Link>
            </li>
          );
        })}
        {/* Account is the only way into Settings on small screens. */}
        <li className="flex-1">
          <ProfileMenu variant="compact" onNavigate={closeDrawer} />
        </li>
        <li className="flex-1">
          <button
            type="button"
            onClick={() => (drawerOpen ? closeDrawer() : openDrawer())}
            className={cn(
              "flex h-full w-full flex-col items-center justify-center gap-0.5 text-[10px] font-medium",
              drawerOpen
                ? "text-brand"
                : "text-muted-foreground hover:text-foreground",
            )}
            aria-label="More navigation"
            aria-expanded={drawerOpen}
          >
            <MoreHorizontal className="size-5" aria-hidden />
            <span>More</span>
          </button>
        </li>
      </ul>
    </nav>
  );
}
